import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError, timer } from 'rxjs';
import { retryWhen, switchMap } from 'rxjs/operators';

@Injectable()
export class HttpOfflineRetryInterceptor implements HttpInterceptor {
  private readonly retryDelayMs = 5000;
  private readonly maxRetries = 3;

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // ONLY GET (NO PUT/POST/PATCH/DELETE etc.) - because for other methods we can have side effects (double creation) on BE and we can't just repeat them without user action
    if (request?.method !== 'GET') {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      retryWhen(errors =>
        errors.pipe(
          switchMap((error, index) => {
            const attempt = index + 1;

            if (!this.shouldRetry(error) || attempt > this.maxRetries) {
              return throwError(() => error);
            }

            return timer(this.retryDelayMs);
          }),
        ),
      ),
    );
  }

  private shouldRetry(error: unknown): boolean {
    return (
      error instanceof HttpErrorResponse &&
      error.status === 0 &&
      !navigator.onLine
    );
  }
}
